/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcomeback1Inputs */

const en_welcomeback1 = /** @type {(inputs: Welcomeback1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcome back`)
};

const de_welcomeback1 = /** @type {(inputs: Welcomeback1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Willkommen zurück`)
};

/**
* | output |
* | --- |
* | "Welcome back" |
*
* @param {Welcomeback1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const welcomeback1 = /** @type {((inputs?: Welcomeback1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcomeback1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_welcomeback1(inputs)
	return de_welcomeback1(inputs)
});
export { welcomeback1 as "welcomeBack" }